import Vue from 'vue'
import VueRouter, {Route} from 'vue-router'
import Layout from '@/layout/Layout'
import store from '../store'
import routers from '../router'
import Shop from '@/views/Shop/index'
import UserAdmin from '@/views/UserAdmin/index'
import ServiceMarket from '@/views/Service/index'
import SShop from '@/views/Service/components/ServiceProviderShop/index'
import { getShopIdByDomain } from '@/api/shop'

Vue.use(VueRouter)

const routes = [
  {
    path: '/login', // 登录
    name: 'login',
    component: () => import('@/views/Login/Login')
  },
  {
    path: '/bindPage', // 绑定账号
    name: 'bindPage',
    component: () => import('@/views/Login/bindPage')
  },
  {
    path: '/bindPhone', // 绑定账号
    name: 'bindPhone',
    component: () => import('@/views/Login/bindPhone')
  },
  {
    path: '/register', // 注册
    name: 'register',
    component: () => import('@/views/Login/Register')
  },
  {
    path: '/feedback', // 注册
    name: 'feedback',
    component: () => import('@/views/Feedback')
  },
  {
    path: '/404',
    component: () => import('@/views/ErrorPage')
  },
  {
    path: '/findPassword', // 找回密码
    name: 'findPassword',
    component: () => import('@/views/Login/FindPassword')
  },
  {
    path: '/searchImage', // 找回密码
    name: 'searchImage',
    component: () => import('@/views/Search/SearchImage')
  },
  {
    path: '/newInAutumn', // 特定活动
    name: 'newInAutumn',
    component: () => import('@/views/Activity/NewInAutumn')
  },
  {
    path: '/scan', // 特定活动
    name: 'scan',
    component: () => import('@/views/scan')
  },
  {
    path: '/event', // 特定活动
    name: 'event',
    component: () => import('@/views/Activity/Event')
  },
  {
    path: '/draw', // 抽奖活动
    name: 'draw',
    component: () => import('@/views/Activity/Draw')
  },
  {
    path: '/newEvent', // 特定活动
    name: 'newEvent',
    component: () => import('@/views/Activity/newEvent')
  },
  {
    path: '',
    component: Layout,
    redirect: '/index',
    children: [
      {
        path: 'index',
        name: 'index',
        component: () => import('@/views/index.vue'),
      },
      {
        path: 'newArrival',
        name: 'newArrival',
        meta: {
          title: '每日新品'
        },
        component: () => import('@/views/NewArrival.vue'),
      },
      {
        path: 'crossBorderZone',
        name: 'crossBorderZone',
        meta: {
          title: '跨境专区'
        },
        component: () => import('@/views/crossBorderZone.vue'),
      },
      {
        path: 'market',
        name: 'market',
        meta: {
          title: '逛市场'
        },
        component: () => import('@/views/Market.vue'),
      },
      {
        path: 'recommendGoods',
        name: 'recommendGoods',
        meta: {
          title: '热搜店铺'
        },
        component: () => import('@/views/RecommendGoods/index.vue'),
      },
      {
        path: 'brandZone',
        name: 'brandZone',
        meta: {
          title: '品牌专区'
        },
        component: () => import('@/views/BrandZone.vue'),
      },
      {
        path: 'bindSuccess',
        name: 'bindSuccess',
        component: () => import('@/views/bindSuccess.vue')
      },
      {
        path: 'videoZone',
        name: 'videoZone',
        meta: {
          title: '视频专区'
        },
        component: () => import('@/views/VideoZone.vue'),
      },
      {
        path: 'promotionZone',
        name: 'promotionZone',
        meta: {
          title: '促销专区'
        },
        component: () => import('@/views/Promotion/PromotionZone.vue'),
      },
      {
        path: 'discountCoupon',
        name: 'discountCoupon',
        meta: {
          title: '优惠券专区'
        },
        component: () => import('@/views/Promotion/DiscountCoupon.vue'),
      },
      {
        path: 'superFactory',
        name: 'superFactory',
        meta: {
          title: '超级工厂'
        },
        component: () => import('@/views/Factory/SuperFactory.vue'),
      },
      {
        path: 'factoryDetails',
        name: 'factoryDetails',
        meta: {
          title: '超级工厂申请'
        },
        component: () => import('@/views/Factory/FactoryDetails.vue'),
      },
      {
        path: 'moneyOff',
        name: 'moneyOff',
        meta: {
          title: '满减专区'
        },
        component: () => import('@/views/Promotion/MoneyOff.vue'),
      },
      {
        path: 'groupBuying',
        name: 'groupBuying',
        meta: {
          title: '拼货专区'
        },
        component: () => import('@/views/Promotion/GroupBuying.vue'),
      },
      {
        path: 'seckillActivity',
        name: 'seckillActivity',
        meta: {
          title: '秒杀专区'
        },
        component: () => import('@/views/Promotion/SeckillActivity.vue'),
      },
      {
        path: 'pointsMall',
        name: 'pointsMall',
        meta: {
          title: '积分商城'
        },
        component: () => import('@/views/PointsMall.vue'),
      },
      {
        path: 'trainingActivities',
        name: 'trainingActivities',
        meta: {
          title: '活动培训'
        },
        component: () => import('@/views/TrainingActivities.vue'),
      },
      {
        path: 'trainingDetails',
        name: 'trainingDetails',
        component: () => import('@/views/TrainingDetails.vue'),
      },
      {
        path: 'news',
        name: 'news',
        component: () => import('@/views/News.vue'),
      },
      //帮助中心
      {
        path: 'help',
        name: 'help',
        component: () => import('@/views/Help.vue'),
      },
      {
        path: 'category',
        name: 'category',
        meta: {
          title: '商品分类'
        },
        component: () => import('@/views/Category.vue'),
      },
      {
        path: 'searchGoods',
        name: 'searchGoods',
        meta: {
          title: '商品搜索'
        },
        component: () => import('@/views/Search/SearchGoods.vue'),
      },
      {
        path: 'searchShop',
        name: 'searchShop',
        meta: {
          title: '店铺搜索'
        },
        component: () => import('@/views/Search/SearchShop.vue'),
      },
      {
        path: 'activity',
        name: 'activity',
        component: () => import('@/views/Activity/index.vue'),
      },
      {
        path: 'noticeDetails',
        name: 'noticeDetails',
        component: () => import('@/views/NoticeDetails.vue'),
      },
      {
        path: 'noticeBoard',
        name: 'noticeBoard',
        component: () => import('@/views/NoticeBoard.vue'),
      },
      // 活动列表
      {
        path: 'activitiesGoods',
        name: 'activitiesGoods',
        meta: {
          title: '活动'
        },
        component: () => import('@/views/ActivitiesGoods/index'),
      },
      // 活动商品展示
      {
        path: 'activityDetail',
        name: 'activityDetail',
        component: () => import('@/views/ActivitiesGoods/activityDetail'),
      }
    ]
  },
  {
    path: '/service',
    redirect: '/service/serviceMarket',
    component: ServiceMarket,
    children: [
      {
        path: 'serviceMarket',
        name: 'serviceMarket',
        component: () => import('@/views/Service/components/ServiceMarket.vue'),
      }, {
        path: 'serviceBusinesses',
        name: 'serviceBusinesses',
        component: () => import('@/views/Service/components/ServiceBusinesses.vue'),
      }, {
        path: 'serviceCategory',
        name: 'serviceCategory',
        component: () => import('@/views/Service/components/ServiceCategory.vue'),
      }, {
        path: 'searchService',
        name: 'searchService',
        component: () => import('@/views/Service/components/SearchService.vue'),
      }]
  },
  {
    path: '/shop',
    redirect: '/shop/shopIndex',
    component: Shop,
    children: [
      {
        path: 'shopIndex',
        name: 'shopIndex',
        component: () => import('@/views/Shop/components/ShopIndex.vue'),
      },
      {
        path: 'newReleases',
        name: 'newReleases',
        component: () => import('@/views/Shop/components/NewReleases.vue'),
      },
      {
        path: 'goods',
        name: 'goods',
        component: () => import('@/views/Shop/components/Goods.vue'),
      },
      {
        path: 'clearInventory',
        name: 'clearInventory',
        component: () => import('@/views/Shop/components/ClearInventory.vue'),
      },
      {
        path: 'offGoods',
        name: 'offGoods',
        component: () => import('@/views/Shop/components/OffGoods.vue'),
      },
      {
        path: 'download',
        name: 'download',
        component: () => import('@/views/Shop/components/Download.vue'),
      },
      {
        path: 'about',
        name: 'about',
        component: () => import('@/views/Shop/components/About.vue'),
      },
      {
        path: 'goodsDetail',
        name: 'goodsDetail',
        component: () => import('@/views/GoodsDetail/index.vue'),
      },
      {
        path: 'salesPromotion',
        name: 'salesPromotion',
        component: () => import('@/views/Shop/components/SalesPromotion.vue')
      }]
  },
  {
    path: '/serviceShop',
    redirect: '/serviceShop/SShopIndex',
    component: SShop,
    children: [
      {
        path: 'sshopIndex',
        name: 'sshopIndex',
        component: () => import('@/views/Service/components/ServiceProviderShop/SShopIndex.vue'),
      },
      {
        path: 'sshopProduct',
        name: 'sshopProduct',
        component: () => import('@/views/Service/components/ServiceProviderShop/SShopProduct.vue'),
      },
      {
        path: 'sshopAbout',
        name: 'sshopAbout',
        component: () => import('@/views/Service/components/ServiceProviderShop/SShopAbout.vue'),
      },
      {
        path: 'sgoodsDetail',
        name: 'sgoodsDetail',
        component: () => import('@/views/Service/components/ServiceProviderShop/SGoodsDetail.vue'),
      },
    ]
  },
  {
    path: '/user',
    redirect: '/user/userIndex',
    component: UserAdmin,
    children: [
      {
        path: 'userIndex',
        name: 'userIndex',
        component: () => import('@/views/UserAdmin/UserIndex.vue'),
      },
      {
        path: 'addCart',
        name: 'addCart',
        component: () => import('@/views/CartList/AddCart.vue'),
      },
      {
        path: 'cartList',
        name: 'cartList',
        component: () => import('@/views/CartList/index.vue'),
      },
      {
        path: 'orderSettle',
        name: 'orderSettle',
        component: () => import('@/views/OrderSettle/index.vue'),
      },
      {
        path: 'cashierDesk',
        name: 'cashierDesk',
        component: () => import('@/views/UserAdmin/CashierDesk.vue'),  //收银台
      },
      {
        path: 'paySuccess',
        name: 'paySuccess',
        component: () => import('@/views/UserAdmin/PaySuccess.vue'), // 支付成功
      },
      {
        path: 'wechatPay',
        name: 'wechatPay',
        component: () => import('@/views/UserAdmin/WechatPay.vue'),
      },
      {
        path: 'menuLayout',
        name: 'menuLayout',
        component: () => import('@/views/UserAdmin/MenuLayout/index.vue'),
        children: [
          {
            path: 'order',
            name: 'order',
            component: () => import('@/views/UserAdmin/MenuLayout/Order.vue'),
          },
          {
            path: 'orderData',
            name: 'orderData',
            component: () => import('@/views/UserAdmin/MenuLayout/orderData.vue')
          },
          {
            path: 'orderPrinting',
            name: 'orderPrinting',
            component: () => import('@/views/UserAdmin/MenuLayout/orderPrinting.vue')
          },
          {
            path: 'orderEvaluate',
            name: 'orderEvaluate',
            component: () => import('@/views/UserAdmin/MenuLayout/orderEvaluate.vue')
          },
          {
            path: 'exhibition',
            name: 'exhibition',
            component: () => import('@/views/UserAdmin/MenuLayout/exhibition.vue')
          },
          {
            path: 'batchOrder',
            name: 'batchOrder',
            component: () => import('@/views/UserAdmin/MenuLayout/batchOrder.vue')
          },
          {
            path: 'afterSaleAdmin',
            name: 'afterSaleAdmin',
            component: () => import('@/views/UserAdmin/MenuLayout/AfterSaleAdmin.vue'),
          },
          {
            path: 'afterApplication',
            name: 'afterApplication',
            component: () => import('@/views/UserAdmin/MenuLayout/AfterApplication.vue'),
          },
          {
            path: 'serviceDetail',
            name: 'serviceDetail',
            component: () => import('@/views/UserAdmin/MenuLayout/ServiceDetail.vue'),
          },
          {
            path: 'cancelOrder',
            name: 'cancelOrder',
            component: () => import('@/views/UserAdmin/MenuLayout/cancelOrder.vue')
          },
          {
            path: 'orderAdded',
            name: 'orderAdded',
            component: () => import('@/views/UserAdmin/MenuLayout/orderAdded.vue')
          },
          {
            path: 'collectGoods',
            name: 'collectGoods',
            component: () => import('@/views/UserAdmin/MenuLayout/CollectGoods.vue'),
          },
          {
            path: 'collectShops',
            name: 'collectShops',
            component: () => import('@/views/UserAdmin/MenuLayout/CollectShops.vue'),
          },
          {
            path: 'centerMessage',
            name: 'centerMessage',
            component: () => import('@/views/UserAdmin/MenuLayout/centerMessage.vue')
          },
          {
            path: 'addressAdmin',
            name: 'addressAdmin',
            component: () => import('@/views/UserAdmin/MenuLayout/AddressAdmin.vue'),
          },
          {
            path: 'essentialInfo',
            name: 'essentialInfo',
            component: () => import('@/views/UserAdmin/MenuLayout/essentialInfo.vue'),
          },
          {
            path: 'quickLogin',
            name: 'quickLogin',
            component: () => import('@/views/UserAdmin/MenuLayout/quickLogin.vue'),
          },
          {
            path: 'changePassword',
            name: 'changePassword',
            component: () => import('@/views/UserAdmin/MenuLayout/changePassword.vue'),
          },
          {
            path: 'changePhone',
            name: 'changePhone',
            component: () => import('@/views/UserAdmin/MenuLayout/changePhone.vue'),
          },
          {
            path: 'changeUnusePhone',
            name: 'changeUnusePhone',
            component: () => import('@/views/UserAdmin/MenuLayout/changeUnusePhone.vue'),
          },
          {
            path: 'browseRecord',
            name: 'browseRecord',
            component: () => import('@/views/UserAdmin/MenuLayout/BrowseRecord.vue'),
          },{
            path: 'batchDownload',
            name: 'batchDownload',
            component: () => import('@/views/UserAdmin/MenuLayout/batchDownload.vue'),
          },
          {
            path: 'certification',
            name: 'certification',
            component: () => import('@/views/UserAdmin/MenuLayout/Certification.vue'),
          },
          {
            path: 'capitalLi',
            name: 'capitalLi',
            component: () => import('@/views/UserAdmin/MenuLayout/capitalLi.vue')
          },
          {
            path: 'returnEvaluate',
            name: 'returnEvaluate',
            component: () => import('@/views/UserAdmin/MenuLayout/returnEvaluate.vue')
          },
          {
            path: 'propose',
            name: 'propose',
            component: () => import('@/views/UserAdmin/MenuLayout/propose.vue')
          },
          {
            path: 'porApply',
            name: 'porApply',
            component: () => import('@/views/UserAdmin/MenuLayout/porApply.vue')
          },
          // {
          //   path: 'tableRecharge',
          //   name: 'tableRecharge',
          //   component: () => import('@/views/UserAdmin/MenuLayout/tableRecharge.vue')
          // },
          // {
          //   path: 'selrRecharge',
          //   name: 'selrRecharge',
          //   component: () => import('@/views/UserAdmin/MenuLayout/selrRecharge.vue')
          // },
          {
            path: 'adminIntegral',
            name: 'adminIntegral',
            component: () => import('@/views/UserAdmin/MenuLayout/adminIntegral.vue')
          },
          {
            path: 'integralTab',
            name: 'integralTab',
            component: () => import('@/views/UserAdmin/MenuLayout/integralTab.vue')
          },
          {
            path: 'adminCoupon',
            name: 'adminCoupon',
            component: () => import('@/views/UserAdmin/MenuLayout/adminCoupon.vue')
          },
          {
            path: 'distribution',
            name: 'distribution',
            component: () => import('@/views/UserAdmin/MenuLayout/distribution.vue')
          },
          {
            path: 'subCommission',
            name: 'subCommission',
            component: () => import('@/views/UserAdmin/MenuLayout/subCommission.vue')
          },
          {
            path: 'userCommission',
            name: 'userCommission',
            component: () => import('@/views/UserAdmin/MenuLayout/userCommission.vue')
          },
          // {
          //   path: 'memberLevel',
          //   name: 'memberLevel',
          //   component: () => import('@/views/UserAdmin/MenuLayout/MemberLevel.vue'),
          // },
          {
            path: 'authorization',
            name: 'authorization',
            component: () => import('@/views/UserAdmin/MenuLayout/authorization.vue')
          },
          {
            path: 'bandWechat',
            name: 'bandWechat',
            component: () => import('@/views/UserAdmin/MenuLayout/bandWechat.vue')
          },

          {
            path: 'storeOrder',
            name: 'storeOrder',
            component: () => import('@/views/UserAdmin/MenuLayout/storeOrder.vue')
          },
          {
            path: 'cargoShop',
            name: 'cargoShop',
            component: () => import('@/views/UserAdmin/MenuLayout/cargoShop.vue')
          },
          {
            path: 'complaint',
            name: 'complaint',
            component: () => import('@/views/UserAdmin/MenuLayout/complaint.vue')
          },
          {
            path: 'complaintInfo',
            name: 'complaintInfo',
            component: () => import('@/views/UserAdmin/MenuLayout/complaintInfo.vue')
          },
          {
            path: 'complaintRecord',
            name: 'complaintRecord',
            component: () => import('@/views/UserAdmin/MenuLayout/complaintRecord.vue')
          },
          {
            path: 'recordHandle',
            name: 'recordHandle',
            component: () => import('@/views/UserAdmin/MenuLayout/recordHandle.vue')
          },
          {
            path: 'reportList',
            name: 'reportList',
            component: () => import('@/views/UserAdmin/MenuLayout/reportList.vue')
          },
          {
            path: 'subReport',
            name: 'subReport',
            component: () => import('@/views/UserAdmin/MenuLayout/subReport.vue')
          },
          {
            path: 'userBinding',
            name: 'userBinding',
            component: () => import('@/views/UserAdmin/MenuLayout/userBinding.vue')
          },
          {
            path: 'member',
            name: 'member',
            component: () => import('@/views/UserAdmin/MenuLayout/member.vue')
          },
          {
            path: 'paymentMember',
            name: 'paymentMember',
            component: () => import('@/views/UserAdmin/MenuLayout/paymentMember.vue')
          },
          {
            path: 'newsText',
            name: 'newsText',
            component: () => import('@/views/UserAdmin/MenuLayout/newsText.vue')
          },
          {
            path: 'distributionManagement',
            name: 'distributionManagement',
            component: () => import('@/views/UserAdmin/MenuLayout/DistributionManagement.vue')
          }
        ]
      },
    ]
  },
  {
    path: '*',
    redirect: '/index'
  }
]

const router = new VueRouter({
  mode: 'history',
  routes
})
//需要登录的路径
const loginList = ['/user/menuLayout'];

router.beforeEach((to, from, next) => {
  // const domain = location.hostname.replace(/\.test\.cnxieku\.com/g, '')
  const domain = location.hostname.replace(/\.cnxieku\.com/g, '')
  const code = store.state.mallTitle
  console.log("to.meta.title", to.meta.title)
  if (to.meta.title) {
    window.document.title = to.meta.title + '-鞋库网鞋靴批发';
  } else {
    if (store.state.mallName && store.state.mallTitle) {
      document.title = store.state.mallTitle
    } else {
      document.title = '鞋库网'
    }
  }

  /*console.log("上报百度开始"+store.state.mallName+","+store.state.statisticsCode);*/
  //上报统计
  if (store.state.statisticsCode) {
    const head = window.document.getElementsByTagName('body')[0]
    let script=document.createElement('script');
    const scripts=store.state.statisticsCode.replace(/<\/?.+?>/g,"");
    script.innerHTML=scripts;
    head.append(script)
  }
  //登录拦截
  let flag = false;
 // const visitsNum = store.state.visitsNum
  //有效期时间
  //const exp = 1000*60*60*24
  //可以访问的商品详情数
 // const viNum = 5
  /*if(!store.state.token){
    for(let i=0,len=loginList.length;i<len;i++){
      if(to.path.indexOf(loginList[i]) != -1){
        flag = true;
      }
      let dataObj = JSON.parse(visitsNum)
      console.log("访问次数"+dataObj.num);
      if ((new Date().getTime() - dataObj.time) > exp) {
        // 过期删除返回null
        localStorage.removeItem('visitsNum')
        console.log('信息已过期')

      } else {
        if(to.path.indexOf("/shop/goodsDetail") != -1 && dataObj.num>=viNum){
          flag = true;
        }
      }

    }
  }*/

  /*if(!store.state.token && (domain == 'www' || domain == 'localhost')){
    for(var i=0,len=loginList.length;i<len;i++){
      if(to.path.indexOf(loginList[i]) != -1 && to.path.indexOf("/shopIndex")  == -1){
        flag = true;
      }
    }
  }*/
  console.log("是否拦截"+flag+",domain:"+domain)

  if (domain && domain != 'www' && domain != 'localhost' && domain != 'market' && domain != 'user' && domain != '192.168.1.195'
    && JSON.stringify(to.query) == '{}') {
    // 要跳转店铺的独有域名主页
    getShopIdByDomain({ domain }).then(res => {
      const shopId = res.data
      if (shopId) {
        location.href = new Vue().DOMAIN_URL+'/shop/shopIndex?shopId='+shopId
        //next('/shop/shopIndex?shopId=' + shopId)
      } else {
        location.href = new Vue().DOMAIN_URL
      }
    }).catch(err => {
      location.href = new Vue().DOMAIN_URL
    })
  } else {
    /*console.log("router.currentRoute.fullPath="+to.fullPath)
    console.log("location.href="+to.query)*/
   /* if(flag){
      router.replace({
        name: 'login',
        query: { redirect: to.fullPath} // 登录后再跳回此页面时要做的配置
      })
    }else{
      if (to.query.t) {
        store.commit('SET_TOKEN', to.query.t)
        store.dispatch('GetUserInfo')
      }
      next()
    }*/
    if (to.query.t) {
      store.commit('SET_TOKEN', to.query.t)
      store.dispatch('GetUserInfo')
    }
    next()


  }
})

router.afterEach((to, from) => {
  window.scrollTo(0, 0) // 解决页面跳转页面不在顶端
  if (to.query.t) {
    let newQuery = JSON.parse(JSON.stringify(to.query))
    delete newQuery.t
    router.replace({ query: newQuery })
  }
})
export default router
